import React, { forwardRef, Ref } from 'react';

import Flex, { FlexProps } from '@gojob/ui-bits/Flex';
import { Color } from '@gojob/ui-bits/styles/theme';
import useTheme from '@gojob/ui-bits/styles/useTheme';

export interface FlatProps extends Omit<FlexProps<'div'>, 'ref' | 'color'> {
  color?: Color;
}

const Flat = (props: FlatProps, ref: Ref<HTMLDivElement>) => {
  const { color = 'pageBackground', ...other } = props;
  const { colors } = useTheme();

  return (
    <Flex
      ref={ref}
      data-testid="Flat"
      css={{ backgroundColor: colors[color] }}
      justifyContent="center"
      width="100%"
      {...other}
    />
  );
};

export default forwardRef(Flat);
